import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

export default function ProductSectionComponent() {
  const renderProductBackground = (
    <>
      <div className="product-background"></div>
      <div className="visit-our-store-wrapper">
        <div className="visit-our-store-title-img">
          <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
          <div className="visit-our-store-title">Visit our store</div>
        </div>
        <div className="product-btn-wrapper">
          <a href="https://shopee.co.th/shop/582216451/">
            <button className="product-btn-shopee">
              <img
                alt="cat's taste"
                className="product-shopee-icon"
                src="/assets/icons/shopee-icon.svg"
              />
              <div className="product-btn-title">SHOPEE</div>
            </button>
          </a>
          <a href="https://www.lazada.co.th/shop/cat-s-taste">
            <button className="product-btn-lazada">
              <img
                alt="cat's taste"
                className="product-lazada-icon"
                src="/assets/icons/lazada-icon.svg"
              />
              <div className="product-btn-title">Lazada</div>
            </button>
          </a>
        </div>
      </div>
      <div className="anchor-value"></div>
      <div
        className="our-product-title-wrapper"
        style={{ marginBottom: "32px" }}
      >
        <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
        <div className="our-value-title">Our Value</div>
      </div>
      <div className="value-quote-wrapper">
        <div className="description-item-quote">
          <img
            alt="cat's taste"
            className="description-img"
            src="/assets/icons/our-value-sodium-red.png"
          />
          <div className="description-title">No sodium added</div>
        </div>
        <div className="description-item-quote">
          <img
            alt="cat's taste"
            className="description-img"
            src="/assets/icons/our-value-grain-red.png"
          />
          <div className="description-title">Grain Free</div>
        </div>
        <div className="description-item-quote">
          <img
            alt="cat's taste"
            className="description-img"
            src="/assets/icons/our-value-preservative-red.png"
          />
          <div className="description-title">No Preservatives</div>
        </div>
        <div className="description-item-quote">
          <img
            alt="cat's taste"
            className="description-img"
            src="/assets/icons/our-value-quality-red.png"
          />
          <div className="description-title">Japanese quality</div>
        </div>
        <div className="description-item-quote">
          <img
            alt="cat's taste"
            className="description-img"
            src="/assets/icons/our-value-human-red.png"
          />
          <div className="description-title">HUMAN GRADE FOOD</div>
        </div>
      </div>
    </>
  );

  const renderTastyProduct = (
    <>
      <div id="tasty" className="anchor-tasty" />
      <div className="tasty-product-subtitle">
        <img alt="cat's taste" src="/assets/icons/cat-mouth.svg" />
        <div className="carousel-title-tasty">Tasty</div>
      </div>
      <div className="tasty-product-grid">
        <a className="product-card" href="product-item/chicken-jelly">
          <div className="product-card-img-tuna-chicken-jelly" />
          <div className="carousel-item-title">
            Tuna topped with Chicken in Jelly
          </div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">สูตรปลาทูน่าไก่ในเยลลี่</div>
          <div className="carousel-btn-wrapper">
            <a
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?shopCollection=137378615"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.766b5b1foO6sbp&q=All-Products&shop_category_ids=1205129&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
        <a className="product-card" href="product-item/chicken-gravy">
          <div className="product-card-img-tuna-chicken-gravy" />
          <div className="carousel-item-title">
            Tuna topped with Chicken in Gravy
          </div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">สูตรปลาทูน่าไก่ในเกรวี่</div>
          <div className="carousel-btn-wrapper">
            <a
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?shopCollection=137378615"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.766b5b1foO6sbp&q=All-Products&shop_category_ids=1205129&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
        <a className="product-card" href="product-item/just-tuna-jelly">
          <div className="product-card-img-just-tuna-jelly" />
          <div className="carousel-item-title">Just Tuna! in Jelly</div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเยลลี่</div>
          <div className="carousel-btn-wrapper">
            <a
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378602"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1f5wFmsX&q=All-Products&shop_category_ids=1205128&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
        <a className="product-card" href="product-item/just-tuna-gravy">
          <div className="product-card-img-just-tuna-gravy" />
          <div className="carousel-item-title">Just Tuna! in Gravy</div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">สูตรปลาทูน่าในเกรวี่</div>
          <div className="carousel-btn-wrapper">
            <a
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378602"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1f5wFmsX&q=All-Products&shop_category_ids=1205128&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
        <a className="product-card" href="product-item/shirasu-jelly">
          <div className="product-card-img-shirasu-in-jelly" />
          <div className="carousel-item-title">
            Tuna topped with Shirasu in Jelly
          </div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่าหน้าชิระสุในเยลลี่
          </div>
          <div className="carousel-btn-wrapper">
            <a
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378621"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1fMekH5s&q=All-Products&shop_category_ids=1205131&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
        <a className="product-card" href="product-item/shirasu-gravy">
          <div className="product-card-img-shirasu-in-gravy" />
          <div className="carousel-item-title">
            Tuna topped with Shirasu in Gravy
          </div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่าหน้าชิระสุในเกรวี่
          </div>
          <div className="carousel-btn-wrapper">
            <a
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378621"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1fMekH5s&q=All-Products&shop_category_ids=1205131&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
        <a className="product-card" href="product-item/salmon-jelly">
          <div className="product-card-img-salmon-in-jelly" />
          <div className="carousel-item-title">
            Tuna topped with Salmon in Jelly
          </div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่าหน้าแซลม่อนในเยลลี่
          </div>
          <div className="carousel-btn-wrapper">
            <a
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378630"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1flbME86&q=All-Products&shop_category_ids=1205132&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
        <a className="product-card" href="product-item/salmon-gravy">
          <div className="product-card-img-salmon-in-gravy" />
          <div className="carousel-item-title">
            Tuna topped with Salmon in Gravy
          </div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่าหน้าแซลม่อนในเกรวี่
          </div>
          <div className="carousel-btn-wrapper">
            <a
              id="healthy"
              className="carousel-btn"
              href="https://shopee.co.th/shop/582216451/search?page=0&shopCollection=137378630"
            >
              SHOPEE
            </a>
            <a
              className="carousel-btn"
              href="https://www.lazada.co.th/cat-s-taste/?spm=a2o4m.10453683.0.0.13c45b1flbME86&q=All-Products&shop_category_ids=1205132&from=wangpu&sc=KVUG"
            >
              LAZADA
            </a>
          </div>
        </a>
      </div>
    </>
  );

  const renderHealthyProduct = (
    <>
      <div className="healthy-product-subtitle">Healthy Tasty</div>
      <div className="healthy-product-grid">
        <Link className="product-card" to="/product-item">
          <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
          <div className="carousel-item-title">Tuna in Jelly (Skin & Fur!)</div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            แมวสูตรปลาทูน่า (เติมมะเขือเทศ)
          </div>
          <div className="carousel-btn-wrapper">
            <button className="carousel-btn">SHOPEE</button>
            <button className="carousel-btn">LAZADA</button>
          </div>
        </Link>
        <Link className="product-card" to="/product-item">
          <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
          <div className="carousel-item-title">Tuna in Jelly (Joint!)</div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่า (เติมมะละกอ)
          </div>
          <div className="carousel-btn-wrapper">
            <button className="carousel-btn">SHOPEE</button>
            <button className="carousel-btn">LAZADA</button>
          </div>
        </Link>
        <Link className="product-card" to="/product-item">
          <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
          <div className="carousel-item-title">Tuna in Jelly (Digestion!)</div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่า (เติมฟักทอง)
          </div>
          <div className="carousel-btn-wrapper">
            <button className="carousel-btn">SHOPEE</button>
            <button className="carousel-btn">LAZADA</button>
          </div>
        </Link>
        <Link className="product-card" to="/product-item">
          <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
          <div className="carousel-item-title">Tuna in Jelly (Hairball!)</div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่า (เติมมะม่วง)
          </div>
          <div className="carousel-btn-wrapper">
            <button className="carousel-btn">SHOPEE</button>
            <button className="carousel-btn">LAZADA</button>
          </div>
        </Link>
        <Link className="product-card" to="/product-item">
          <img alt="cat's taste" src="/assets/icons/tasty-products.png" />
          <div className="carousel-item-title">Tuna in Jelly (Calcium!)</div>
          <div className="carousel-item-subtitle1">อาหารเปียกแมว</div>
          <div className="carousel-item-subtitle2">
            สูตรปลาทูน่า (เติมปลาแอนโชวี่)
          </div>
          <div className="carousel-btn-wrapper">
            <button className="carousel-btn">SHOPEE</button>
            <button className="carousel-btn">LAZADA</button>
          </div>
        </Link>
      </div>
    </>
  );

  return (
    <div>
      {renderProductBackground}
      <div className="tasty-product-background"></div>
      <div className="tasty-product-wrapper">
        {renderTastyProduct}
        {/* {renderHealthyProduct} */}
      </div>
    </div>
  );
}
